<div class="finance-view-layout">
    <div class="flex flex-col justify-start">
        <ag-grid-angular class="ag-theme-quartz finances-grid"
                         [rowData]="rowData()"
                         [columnDefs]="colDefs()"
                         [defaultColDef]="defaultColDef"
                         [gridOptions]="gridOptions"
                         [groupDisplayType]="'groupRows'"
                         (cellValueChanged)="handleCellValueChanged($event)"
                         (cellEditingStopped)="handleCellEditingStopped($event)"
                         (gridReady)="onGridReady($event)">
        </ag-grid-angular>
        @if (isBusinessContext) {
            <app-finances-debt debtContext="business"/>
        }
    </div>
    <div class="document-preview" [appFadeAnimation]="shouldShowDocumentView()">
        @if (shouldShowDocumentView()) {
            <app-document-preview [documentId]="documentId()" />
        }
    </div>
</div>

